const ZIP_CODE = /^\d{5}$/

export type ParsedZipCodes = {
	zipCodes: string[],
	invalid: string[],
}

// Accepts a list pasted from a spreadsheet or typed by hand: zips separated by
// newlines, commas, semicolons or spaces. Valid zips come back sorted and
// de-duplicated, matching how the API stores them.
export default function parseZipCodes( text: string ): ParsedZipCodes {
	const tokens = text.split( /[\s,;]+/ ).filter( ( token ) => token !== '' )
	const zipCodes = new Set<string>()
	const invalid: string[] = []

	tokens.forEach( ( token ) => {
		if ( ZIP_CODE.test( token ) ) {
			zipCodes.add( token )
		} else {
			invalid.push( token )
		}
	} )

	return { zipCodes: Array.from( zipCodes ).sort( ( a, b ) => a.localeCompare( b ) ), invalid }
}
